<template>
  <div>
    <div class="form-row"><h3>Manage Web Login User List</h3></div>
    <div class="e-card">
      <div id="activeWebUsers" style="display: none">
        <ejs-grid
          :dataSource="activityUsers()"
          ref="refWebActiveUserList"
          :created="created"
          enablePersistence="true"
          :selection-settings="selectionOptions"
          :commandClick="commandClick"
          :allowSorting="true"
          :allowPaging="true"
          :pageSettings="activePageSettings"
          :toolbar="toolbarOptions"
        >
          <e-columns>
            <e-column
              field="userId"
              headerText="User ID"
              textAlign="Left"
              :isPrimaryKey="true"
              width="0"
            ></e-column>
            <e-column
              headerText="Edit"
              width="10%"
              textAlign="Left"
              :commands="commands"
            ></e-column>
            <e-column
              field="userProfile.userFullName"
              width="15%"
              headerText="Name"
              textAlign="Left"
            ></e-column>
            <e-column field="userName" width="22%" headerText="Email" textAlign="Left"></e-column>
            <e-column
              field="userProfile.address"
              width="25%"
              headerText="Address"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.cityName"
              width="10%"
              headerText="City"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.provinceName"
              width="15%"
              headerText="Province Name"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.postalCode"
              width="14%"
              headerText="Postal Code"
              textAlign="Left"
            ></e-column>
            <e-column
              field="memberShip.isApproved"
              width="0"
              headerText="Active"
              textAlign="Left"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div id="inactiveWebUsers" style="display: none">
        <ejs-grid
          :dataSource="inActivityUsers()"
          ref="refWebInactiveUserList"
          :created="created"
          :selection-settings="selectionOptions"
          :commandClick="inactiveWebUsercommandClick"
          :allowSorting="true"
          :allowPaging="true"
          :pageSettings="inactiveWebUserpageSettings"
          :toolbar="toolbarOptions"
        >
          <e-columns>
            <e-column
              field="userId"
              headerText="User ID"
              textAlign="Left"
              :isPrimaryKey="true"
              width="0"
            ></e-column>
            <e-column
              headerText="Edit"
              width="12%"
              :commands="inactiveWebUserCommands"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.userFullName"
              width="13%"
              headerText="Name"
              textAlign="Left"
            ></e-column>
            <e-column field="userName" width="22%" headerText="Email" textAlign="Left"></e-column>
            <e-column
              field="userProfile.address"
              width="27%"
              headerText="Address"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.cityName"
              width="10%"
              headerText="City"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.provinceName"
              width="15%"
              headerText="Province Name"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.postalCode"
              width="14%"
              headerText="Postal Code"
              textAlign="Left"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div id="lockedWebUsers" style="display: none">
        <ejs-grid
          :dataSource="lockedUsers()"
          ref="refWebLockedUserList"
          :created="created"
          :selection-settings="selectionOptions"
          :commandClick="unlockWebUsercommandClick"
          :allowSorting="true"
          :allowPaging="true"
          :pageSettings="inactiveWebUserpageSettings"
          :toolbar="toolbarOptions"
        >
          <e-columns>
            <e-column
              field="userId"
              headerText="User ID"
              textAlign="Left"
              :isPrimaryKey="true"
              width="0"
            ></e-column>
            <e-column
              headerText="Edit"
              width="12%"
              :commands="lockedWebUserCommands"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.userFullName"
              width="13%"
              headerText="Name"
              textAlign="Left"
            ></e-column>
            <e-column field="userName" width="22%" headerText="Email" textAlign="Left"></e-column>
            <e-column
              field="userProfile.address"
              width="27%"
              headerText="Address"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.cityName"
              width="10%"
              headerText="City"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.provinceName"
              width="15%"
              headerText="Province Name"
              textAlign="Left"
            ></e-column>
            <e-column
              field="userProfile.postalCode"
              width="14%"
              headerText="Postal Code"
              textAlign="Left"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div id="webHistoricalInformation" style="display: none">
        <ejs-grid
          :dataSource="userEvenLogs()"
          ref="refWebHistoricalInfoList"
          :created="created"
          :selection-settings="selectionOptions"
          :allowSorting="true"
          :allowPaging="true"
          :pageSettings="webHistoricalInfoPageSettings"
          :toolbar="toolbarOptions"
        >
          <e-columns>
            <e-column
              field="userId"
              headerText="User ID"
              textAlign="Left"
              :isPrimaryKey="true"
              width="0"
            ></e-column>
            <e-column
              field="userFullName"
              width="12%"
              headerText="Name"
              textAlign="Left"
            ></e-column>
            <e-column field="userName" width="20%" headerText="Email" textAlign="Left"></e-column>
            <e-column field="eventType" headerText="Action Updated" textAlign="Left"></e-column>
            <e-column field="" headerText="Permission Changed" textAlign="Left"></e-column>
            <e-column
              field="logDate"
              headerText="Date Action Updated"
              textAlign="Left"
              type="date"
              format="MMM dd, yyyy"
            ></e-column>
            <e-column headerText="Updated User" textAlign="Left" field="updateUserName"></e-column>
          </e-columns>
        </ejs-grid>
      </div>
      <div style="margin: 0px">
        <div tabindex="0" id="basic">
          <div class="form-row">
            <ejs-tab
              id="webUser_tab"
              class="e-background"
              ref="refWebUserTabInstance"
              :selecting="tabSelect"
              :selected="tabSelected"
              :created="tabCreated"
            >
              <e-tabitems>
                <e-tabitem :header="headerText0" :content="content0"></e-tabitem>
                <e-tabitem :header="headerText1" :content="content1"></e-tabitem>
                <e-tabitem :header="headerText2" :content="content2"></e-tabitem>
                <e-tabitem :header="headerText3" :content="content3"></e-tabitem>
              </e-tabitems>
            </ejs-tab>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from "@syncfusion/ej2-vue-grids";
import { TabPlugin } from "@syncfusion/ej2-vue-navigations";
import {
  FETCH_ACTIVE_INACTIVE_USERS,
  FETCH_WEB_USERS_EVENT_LOG,
  ACTIVATE_USER,
  UNLOCK_USER,
} from "../store";

Vue.use(GridPlugin);
Vue.use(TabPlugin);

export default {
  name: "Users",
  created() {},
  computed: {},
  data() {
    return {
      headerText0: { text: "Active Users" },
      headerText1: { text: "Inactive Users" },
      headerText2: { text: "Locked Users" },
      headerText3: { text: "Historical Information" },
      content0: "#activeWebUsers",
      content1: "#inactiveWebUsers",
      content2: "#lockedWebUsers",
      content3: "#webHistoricalInformation",
      selectionOptions: {
        type: "Single",
        enableSimpleMultiRowSelection: false,
        enableToggle: true,
        persistSelection: true,
      },
      toolbarOptions: ["Search"],
      activePageSettings: { pageSize: 10 },
      inactiveWebUserpageSettings: { pageSize: 10 },
      webHistoricalInfoPageSettings: { pageSize: 10 },
      commands: [
        {
          type: "Edit",
          buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" },
        },
      ],
      inactiveWebUserCommands: [{ buttonOption: { content: "Active", cssClass: "e-info" } }],
      lockedWebUserCommands: [{ buttonOption: { content: "Unlock", cssClass: "e-info" } }],
      refreshTime: null,
    };
  },
  mounted() {
    this.$refs.refWebActiveUserList.ej2Instances.searchSettings.key = "";
    this.$refs.refWebUserTabInstance.ej2Instances.animation.previous.effect = "FadeIn";
    this.$refs.refWebUserTabInstance.ej2Instances.animation.next.effect = "FadeIn";
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar

      if (this.$refs.refWebActiveUserList) {
        const refWebActiveUserListSearchEle = document.getElementById(
          `${this.$refs.refWebActiveUserList.$el.id}_searchbar`,
        );
        if (refWebActiveUserListSearchEle) {
          refWebActiveUserListSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refWebActiveUserList.$el.id);
          });
        }
      }

      // Added clear button and its functionalities to Searchbar

      if (this.$refs.refWebInactiveUserList) {
        const refWebInactiveUserListSearchEle = document.getElementById(
          `${this.$refs.refWebInactiveUserList.$el.id}_searchbar`,
        );
        if (refWebInactiveUserListSearchEle) {
          refWebInactiveUserListSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refWebInactiveUserList.$el.id);
          });
        }
      }

      // Added clear button and its functionalities to Searchbar

      if (this.$refs.refWebLockedUserList) {
        const refWebLockedUserListSearchEle = document.getElementById(
          `${this.$refs.refWebLockedUserList.$el.id}_searchbar`,
        );
        if (refWebLockedUserListSearchEle) {
          refWebLockedUserListSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refWebLockedUserList.$el.id);
          });
        }
      }

      // Added clear button and its functionalities to Searchbar

      if (this.$refs.refWebHistoricalInfoList) {
        const refWebHistoricalInfoListSearchEle = document.getElementById(
          `${this.$refs.refWebHistoricalInfoList.$el.id}_searchbar`,
        );
        if (refWebHistoricalInfoListSearchEle) {
          refWebHistoricalInfoListSearchEle.addEventListener("keyup", (e) => {
            this.clearSearchEventListener(e, this.$refs.refWebHistoricalInfoList.$el.id);
          });
        }
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove("e-search-icon");
      clearBtnEle.classList.add("e-clear-icon");

      clearBtnEle.addEventListener("click", () => {
        e.target.value = "";
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === "") {
        const clearBtn = document.getElementById(`${gridId}_clearbutton`);
        if (clearBtn) {
          clearBtn.remove();
        }
      }
    },
    async tabCreated() {
      const tabObj = this.$refs.refWebUserTabInstance.ej2Instances;
      const tagId = tabObj.selectedID;
      if (tagId === "0") {
        await this.$store.dispatch(FETCH_ACTIVE_INACTIVE_USERS);
      } else if (tagId === "1") {
        await this.$store.dispatch(FETCH_ACTIVE_INACTIVE_USERS);
      } else if (tagId === "2") {
        await this.$store.dispatch(FETCH_WEB_USERS_EVENT_LOG);
      }
    },
    async tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    async tabSelected(e) {
      const tagId = e.selectedIndex;
      if (tagId === 0) {
        await this.$store.dispatch(FETCH_ACTIVE_INACTIVE_USERS);
      } else if (tagId === 1) {
        await this.$store.dispatch(FETCH_ACTIVE_INACTIVE_USERS);
      } else if (tagId === 2) {
        await this.$store.dispatch(FETCH_WEB_USERS_EVENT_LOG);
      }
    },
    activityUsers() {
      return this.$store.getters.activeUsers;
    },
    inActivityUsers() {
      return this.$store.getters.inactiveUsers;
    },
    lockedUsers() {
      return this.$store.getters.lockedUsers;
    },
    userEvenLogs() {
      return this.$store.getters.webUserEventLogList;
    },
    async inactiveWebUsercommandClick(args) {
      // this.$parent.notificationToasts.length = 0;
      const { userName } = args.rowData;
      try {
        await this.$store.dispatch(ACTIVATE_USER, { userName }).then((resp) => {
          if (resp.status === 200) {
            // this.webUsers();
            this.$store.dispatch(FETCH_ACTIVE_INACTIVE_USERS);
            this.$parent.notificationToasts.push({
              title: "Success!",
              content: "User activate successfully. Please, check active user tab.",
              cssClass: "e-toast-success",
              timeOut: 5000,
            });
          }
          // e.updateData(this.$store.getters.melissaAddresses);
        });
      } catch (err) {
        this.$parent.notificationToasts.push({
          title: "Error!",
          content: "Sorry, Something went wrong. Please try again later.",
          cssClass: "e-toast-danger",
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    async commandClick(args) {
      if (args.commandColumn.type === "Edit") {
        const { userId } = args.rowData;
        this.$router.push({
          name: "ManageWebLoginInfo",
          params: { id: userId },
        });
      }
    },
    async unlockWebUsercommandClick(args) {
      // this.$parent.notificationToasts.length = 0;
      const { userName } = args.rowData;
      try {
        await this.$store.dispatch(UNLOCK_USER, { userName }).then((resp) => {
          if (resp.status === 200) {
            // this.webUsers();
            this.$store.dispatch(FETCH_ACTIVE_INACTIVE_USERS);
            this.$parent.notificationToasts.push({
              title: "Success!",
              content: "User unlock successfully. Please, check active user tab.",
              cssClass: "e-toast-success",
              timeOut: 5000,
            });
          }
          // e.updateData(this.$store.getters.melissaAddresses);
        });
      } catch (err) {
        this.$parent.notificationToasts.push({
          title: "Error!",
          content: "Sorry, Something went wrong. Please try again later.",
          cssClass: "e-toast-danger",
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>

<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
.wrap {
  box-sizing: border-box;
  margin: 0 auto;
  padding: 20px 10px;
  width: 340px;
}

#loader {
  color: #008cff;
  height: 40px;
  left: 45%;
  position: absolute;
  top: 45%;
  width: 30%;
}

.e-content .e-item {
  font-size: 12px;
  margin: 10px;
  text-align: justify;
}
/* .container {
min-width: 350px;
margin: 0 10px;
} */

.info {
  margin: 10px;
  font-weight: bold;
}

.e-tab .e-content > .e-item.e-active.collapse {
  display: none;
}

.e-tab .e-tab-header .e-indicator.collapse {
  display: none;
}
.e-tab.e-background .e-tab-header {
  background: #0f4b90;
  border: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap {
  background: #0f4b90;
  border-radius: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap {
  background: #0f4b90 !important;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus {
  background: #0f4b90;
}
</style>
